import {
  LatestReleaseNote,
  ReleaseNote,
  ReleaseNoteApp,
  ReleaseNoteHistory,
  SaveReleaseNote,
} from '@/types';
import {
  Core,
  RELEASE_NOTES,
  RELEASE_NOTE,
  RELEASE_NOTES_LATEST,
  RELEASE_NOTES_HISTORY,
  RELEASE_NOTES_DISMISS,
} from '../Core';

export const RELEASE_NOTE_HISTORY_PAGE_SIZE = 10;

class ReleaseNotes extends Core {
  getLatest = async () => this.get<LatestReleaseNote>(RELEASE_NOTES_LATEST());

  getHistory = async (skip = 0, take = RELEASE_NOTE_HISTORY_PAGE_SIZE) =>
    this.get<ReleaseNoteHistory>(RELEASE_NOTES_HISTORY(skip, take));

  dismiss = async (versionLabel: string) =>
    this.post(RELEASE_NOTES_DISMISS(), { versionLabel });

  getAll = async (app?: ReleaseNoteApp) => {
    const params = new URLSearchParams();
    if (app) params.set('app', app);
    const query = params.toString();
    return this.get<ReleaseNote[]>(
      `${RELEASE_NOTES()}${query ? `?${query}` : ''}`,
    );
  };

  getById = async (id: number) => this.get<ReleaseNote>(RELEASE_NOTE(id));

  create = async (data: SaveReleaseNote) =>
    this.post<ReleaseNote>(RELEASE_NOTES(), data);

  update = async (id: number, data: SaveReleaseNote) =>
    this.put<ReleaseNote>(RELEASE_NOTE(id), data);

  deleteById = async (id: number) => this.delete(RELEASE_NOTE(id));
}

export const releaseNotes = new ReleaseNotes();
